<template>
  <div>
    <!-- Table Container Card -->
    <b-card id="page-catalogs" no-body class="mb-0 p-2">
      <b-card-header
        class="pl-0 pr-0 d-flex align-items-between justify-content-center"
      >
        <b-col cols="12" md="4">
          <b-card-title
            ><h2>{{ $t(label("title")) }}</h2></b-card-title
          >
        </b-col>

        <b-col cols="12" md="8" class="d-none d-md-table">
          <b-col
            cols="12"
            class="d-flex align-items-between justify-content-end"
          >
            <b-button id="tooltip-create" variant="primary" @click="onCreate">
              <feather-icon
                aria-label="Register"
                icon="PlusIcon"
                class="mr-25"
              />
              <span class="text-nowrap">{{ $t(label("register")) }}</span>
            </b-button>
          </b-col>
        </b-col>

        <b-tooltip
          placement="top"
          target="tooltip-create"
          triggers="hover"
          @click="onInfo"
        >
          <strong>
            <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
            {{ $t("tutorial") }}
          </strong>
          <span> </span>
        </b-tooltip>
      </b-card-header>

      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />
      <!-- table -->
      <b-table
        id="catalogs-table"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="d-none d-md-table shadow-sm !rounded"
      >
        <!-- A custom formatted header cell for field 'name' -->
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(name)="data">
          <slot name="cell-name" :data="data">
            {{ data.item.name || "N/A" }}
          </slot>
        </template>

        <template #cell(actions)="data">
          <feather-icon
            class="text-success mr-25 cursor-pointer"
            aria-label="Show details"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.guid)"
          />

          <feather-icon
            class="text-primary mr-25 cursor-pointer"
            aria-label="Edit details"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.guid)"
          />

          <feather-icon
            class="text-danger cursor-pointer"
            aria-label="Delete details"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.guid)"
          />
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>

      <!-- pagination -->
      <div class="mx-2 d-none d-md-table">
        <b-row>
          <b-col cols="12" md="2" class="mb-2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">{{
                $t("perPage")
              }}</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                @change="handlePerPageChange"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              @change="handlePageChange"
              first-number
              last-number
            >
              <template #prev-text>
                <feather-icon size="18" icon="ChevronLeftIcon" />
              </template>
              <template #next-text>
                <feather-icon size="18" icon="ChevronRightIcon" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
      <!-- List for mobile devices -->
      <div id="list-container" class="d-block d-md-none mt-1 list-container">
        <b-list-group>
          <b-list-group-item
            v-for="(item, key) in items"
            :key="item.guid"
            class="d-flex flex-column align-items-start border border-primary rounded mb-1"
          >
            <div class="d-flex w-100 justify-content-between mb-1">
              <strong>{{ item.name || "N/A" }}</strong>

              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item @click="onShow(item.guid)">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("show") }}
                    <feather-icon
                      class="text-success mr-25 cursor-pointer"
                      aria-label="Show details"
                      size="18"
                      icon="FileTextIcon"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="onEdit(item.guid)">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("edit") }}
                    <feather-icon
                      class="text-primary mr-25 cursor-pointer"
                      aria-label="Edit details"
                      size="18"
                      icon="EditIcon"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="onDelete(item.guid)">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("delete") }}
                    <feather-icon
                      class="text-danger cursor-pointer"
                      aria-label="Delete details"
                      size="18"
                      icon="Trash2Icon"
                    />
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-list-group-item>
          <b-list-group-item v-if="items.length == 0" class="text-center">
            {{ $t("notRegister") }}
          </b-list-group-item>
          <b-list-group-item v-if="loading" class="text-center">
            <b-spinner class="align-middle ml-50" variant="primary"></b-spinner>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BButton,
  BTable,
  BTooltip,
  BSpinner,
  BFormSelect,
  BFormFile,
  BOverlay,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BRow,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import { allCatalogs, deleteCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import Filterss from "../components/filters/Filterss.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCol,
    BButton,
    BTable,
    BTooltip,
    BSpinner,
    BFormSelect,
    BFormFile,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BRow,
    Filterss,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "catalogs",
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "name", key: "name", sortable: true },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
  }),

  created() {
    this.loadCatalogs();
  },

  async mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },

  methods: {
    label(field) {
      return `pages.catalogs.table.${field}`;
    },

    labelHeader(field) {
      return `pages.catalogs.table.tableHeader.${field}`;
    },

    loadCatalogs() {
      try {
        const param = this.chargeParams();
        this.loading = !this.loading;
        allCatalogs(param)
          .then((resp) => {
            const data = _.get(resp, "data");
            this.items = data?.items || [];
            this.totalRows = data?.totalRows || 0;
            this.hasNextPage = data?.currentPage < data?.totalPages || 0;
          })
          .catch((error) => {
            console.log("error", error);
            this.alertToast("danger", `Alerta codigo`, error.message);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },

    loadCatalogsInfinity() {
      if (!this.hasNextPage) return;

      try {
        this.loading = true;
        const params = this.chargeParams();

        allCatalogs(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading catalogs infinitely", error);
          });
      } catch (error) {
        console.error("Error loading data", error.message);
      }
    },

    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }
      return getParams(arrParams);
    },

    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadCatalogsInfinity();
      }
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.loadCatalogs();
    },

    handlePerPageChange() {
      this.loadCatalogs();
    },

    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }
      return true;
    },

    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadCatalogs();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },

    resetFilters() {
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadCatalogs();
    },

    onCreate() {
      this.$router.push({
        name: "catalogCreate",
        params: {
          option: 1,
        },
      });
    },

    onShow(guid) {
      this.$router.push({
        name: "catalogEdit",
        params: {
          option: 2,
          guid,
        },
      });
    },

    onEdit(guid) {
      this.$router.push({
        name: "catalogEdit",
        params: {
          option: 3,
          guid,
        },
      });
    },

    onDelete(guid) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteCatalog(guid)
            .then(() => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadCatalogs();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", `Alerta codigo`, error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    onInfo() {},

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>
<style lang="scss">
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
